/**
 * Normalizes a legacy `SharedDataService` attribute into a real boolean.
 *
 * `StripeService.getCurrentPlan()` stores `on_trial`/`used_trial` under the
 * `SharedDataService` "onTrial"/"usedTrial" attribute keys exactly as the
 * backend returns them — real booleans (`CurrentSubscriptionService.php`
 * emits `on_trial: $onTrial` where `$onTrial` is `$subscription->onTrial()`,
 * a PHP bool). A strict `=== "true"` string compare against that value is
 * always `false`, silently disabling every rule gated on it (issue #596: the
 * Oct 2023 "trialing users never see their plan flagged current" /
 * "trialing users see every tier" rules, and the header's "14-day Trial"
 * suffix, were all dead for this reason).
 *
 * Every reader of these two attributes must go through this helper instead
 * of re-introducing a string compare at the call site.
 */
export function isTruthyFlag(value: unknown): boolean {
  return value === true || value === "true";
}
